import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import TextRenderer from '../../../TextRenderer';
import CommissionViewer from '../../../DaEditorWrapper/Viewer/Commission';
import { isEditorTextEmpty } from '../../../DaEditorWrapper/utils';
import MeasuredTorpedo from '../../../Torpedo/MeasuredTorpedo';
import DeviationThumbView from '../../../DeviationViews/Thumb/Standard';
import { MeasuredCookieType } from '../../../Measured';
import MediaService from '../../../utils/DeviationMediaService';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import s from './Commission.scss';
var exampleRenderer = function (renderProps, item) {
    return (React.createElement(DeviationThumbView, { className: s['example'], deviation: item.dto.deviation, width: item.width, height: item.height }));
};
export var CommissionDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, isMature = _b.isMature, _c = _b.commission, _d = _c === void 0 ? {} : _c, _e = _d.examples, examples = _e === void 0 ? [] : _e, textContent = _b.textContent;
    var isEmpty = textContent && isEditorTextEmpty(textContent);
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation })),
        !isEmpty && (React.createElement(TextRenderer, { className: s['description'], textContent: textContent, viewerKey: deviation.deviationId, reactViewer: CommissionViewer })),
        examples.length > 0 && (React.createElement("div", { className: s['examples'] },
            React.createElement(MeasuredTorpedo, { container: { width: 780 }, items: examples.map(function (item) {
                    var largest = MediaService.getThumbDimensions(item);
                    return {
                        id: "deviation-".concat(item.deviationId),
                        width: largest.width || 0,
                        height: largest.height || 0,
                        deviation: item,
                    };
                }), renderItem: exampleRenderer, cookieDim: "width", cookieType: MeasuredCookieType.BROWSE }))),
        React.createElement("div", { className: s['misc'] }, isMature && React.createElement(MatureIndicator, null))));
};
CommissionDetails.displayName = 'CommissionDetails';
export default CommissionDetails;
//# sourceMappingURL=Commission.js.map